import { IPartnerLnRStatusesView } from 'clickNgo/models/crud/views'

import { IPartnerLnRStatus } from '../../models/reportDetails'

export function mapPartnerLnRStatusFromView(data: IPartnerLnRStatusesView): IPartnerLnRStatus {
  return {
    entryId: data.EntryId,
    geoRegion: data.GeoRegion,
    geoMarket: data.GeoMarket,
    country: data.Country,
    partnerType: data.PartnerType,
    partnerId: data.PartnerId,
    partnerName: data.PartnerName,
    approvalStatus: data.ApprovalStatus,
    modified: data.Modified,
  }
}
